import { IDeserializable } from "./deserializable.model";

export class AppointmentType implements IDeserializable{
  id: number;
  name: string;
  abbreviation: string;
  description: string;
  duration: number;
  defaultCost: number;

  constructor(i?: number, n?: string) {
    if(i && n){
      this.id = i;
      this.name = n;
      const words = this.name.split(" ")
      this.abbreviation = ""
      for(let index in words){
        this.abbreviation += words[index].charAt(0)
      }
    }
  }

  public deserialize(input: any): this {
    Object.assign(this, input);

    if(this.name){
      const words = this.name.split(" ")
      this.abbreviation = ""
      for(let index in words){
        this.abbreviation += words[index].charAt(0)
      }
    }
   
    return this;
  }
}
